import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class TokenService {
	private refreshingSubject = new BehaviorSubject<boolean>(false)

	get isRefreshing$() {
		return this.refreshingSubject.asObservable()
	}

	setRefreshing(value: boolean) {
		this.refreshingSubject.next(value)
	}
}
